import React, { PropsWithChildren } from "react";
import AdminTechpackProvider from "./Techpack/AdminTechpackProvider";
import AdminOrderProvider from "./Order/AdminOrderProvider";

const AdminProvider = ({ children }: PropsWithChildren) => {
  return (
    <AdminTechpackProvider>
      <AdminOrderProvider>{children}</AdminOrderProvider>
    </AdminTechpackProvider>
  );
};

export default AdminProvider;
